import {connect} from "react-redux";

import Grid from "./Grid";
import deltas from "../../redux/actions/deltas";

const {
    addValueToCoursesGridTextFilter,
    removeValueFromCoursesGridTextFilter,
    clearCoursesGridTextFilter,
    cycleCoursesGridColumnSortState,
    setCoursesGridDateFilter,
    clearCoursesGridDateFilter,
} = deltas.actionCreators;

const mapStateToProps = (state) => ({
    rowsFromRedux: state.coursesGrid.filteredSortedData,
    gridStateSliceName: 'coursesGrid',
    backendSorted: false,
});

const mapDispatchToProps = dispatch => ({
    addValueToTextFilter: addValueToCoursesGridTextFilter,
    removeValueFromTextFilter: removeValueFromCoursesGridTextFilter,
    clearTextFilter: clearCoursesGridTextFilter,
    cycleColumnSortState: cycleCoursesGridColumnSortState,
    setDateFilter: setCoursesGridDateFilter,
    clearDateFilter: clearCoursesGridDateFilter,
});

export default connect(mapStateToProps, mapDispatchToProps)(Grid);
